import { Badge } from '@bambi/component-library/src/components/Badge/Badge';

import { defaultCurrencyFormat } from 'src/common/defaultCurrencyFormat';

interface EstimatedRevenueBadgeProps {
  revenue: number;
  className?: string;
}
export const EstimatedRevenueBadge = ({
  revenue,
  className,
}: EstimatedRevenueBadgeProps) => {
  return (
    <div className={className} data-testid="assignment-estimated-revenue">
      <Badge
        label={defaultCurrencyFormat(revenue, false)}
        color="green"
        border
      />
    </div>
  );
};
